export default {
  no_storefront_found: {
    title: 'Nie znaleziono witryny',
    description: 'Utwórz witrynę.',
  },
};
